window.addEventListener("load", function () {
    const iconCharacter = $('#dream-ms-characters .swiper-characters .item');
    iconCharacter.on("click", function () {
        // Dừng tất cả audio đang phát
        $('audio').each(function () {
            this.pause();
            this.currentTime = 0;
        });
        $('.btn-music').removeClass('MS__off active');
        
        const dataType = $(this).closest('.swiper-slide').data('type');
        const dataStt = $(this).data('stt'); // Lấy data-stt của item được click
        $('.swiper-characters .item').removeClass('active');
        $(this).addClass('active');

        $('#dream-ms-characters .box-characters .item').hide();
        // Show đúng item theo type và stt
        $('#dream-ms-characters .box-characters .item[data-type="' + dataType + '"][data-stt="' + dataStt + '"]').show();
    });

    new Swiper(".swiper-characters", {
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            loadPrevNext: false,
            loadOnTransitionStart: false,
        },
        pagination: {
            el: ".swiper-characters-pagination",
            clickable: true
        },
        on: {
            init: function () {
                iconCharacter.eq(0).trigger('click');
            },
            slideChange: function () {
                const activeSlide = this.slides[this.activeIndex];
                const currentItem = $(activeSlide).find('.item').eq(0);
                currentItem.trigger('click');
            }
        }
    });

    $('#dream-ms-characters .swiper-slide').on('wheel', function (e) {
        e.stopPropagation();
    });
    $('#dream-ms-characters .swiper-slide').on('touchend', function (e) {
        e.stopPropagation();
    });

    $('#dream-ms-characters .btn-music').on('click', function (e) {
        e.preventDefault();
    
        const $btn = $(this);
    
        // Nếu đang phát thì bỏ qua
        if ($btn.hasClass('MS__off')) return;
    
        const $item = $btn.closest('.item');
        const $audio = $item.find('audio');
        const audio = $audio[0];
    
        if (audio) {
            const $source = $audio.find('source');
            const src = $source.attr('src');
            const dataSrc = $source.attr('data-src');
    
            // Nếu audio chưa có src, gán src từ data-src và load
            if (!src && dataSrc) {
                $source.attr('src', dataSrc);
                audio.load(); // bắt buộc load lại sau khi set src
            }
    
            // Dừng tất cả audio khác
            $('audio').each(function () {
                this.pause();
                this.currentTime = 0;
            });
    
            // Reset class trên tất cả nút
            $('.btn-music').removeClass('MS__off');
    
            // Bật trạng thái đang phát
            $btn.addClass('MS__off');
    
            // Phát audio
            audio.currentTime = 0;
            audio.play();
    
            // Khi audio kết thúc thì gỡ class
            audio.onended = function () {
                $btn.removeClass('MS__off');
            };
        }
    });
  
});
